(function ($, Cookies) {
    $(document).ready(function () {
        const ms = 1000;
        const delay = parseInt($('#sitecoreLightboxTimerInt').val() * ms);
        const lightboxIdValue = $('#sitecoreLightboxIdentification').val();
        const lightboxViewsLimit = parseInt($('#sitecoreLightboxViewsInt').val());
        const globalLightboxViewsLimit = parseInt($('#sitecoreGlobalLightboxViewsInt').val());
        const globalLightboxCounter = 'global-lightbox-counter';
        const daysUntilExpiry = 1;
        const oneView = 1;

        if (Number.isNaN(delay)) {
            return;
        }
        const isDialogVisible = function () {
            return $('.vds-modal, .vds-notification, .live-form-content').is(':visible');
        };
        const checkTimesLightboxSeen = function () {
            const timesLightboxSeen = parseInt(Cookies.get(lightboxIdValue));
            return timesLightboxSeen || 0;
        };
        const checkTimesGlobalLightboxSeen = function () {
            const globalTimesLightboxSeen = parseInt(Cookies.get(globalLightboxCounter));
            return globalTimesLightboxSeen || 0;
        };
        const isLimitReached = function (loGlobalLightboxViewsLimit, loLightboxViewsLimit) {
            return checkTimesLightboxSeen() >= loLightboxViewsLimit ||
                checkTimesGlobalLightboxSeen() >= loGlobalLightboxViewsLimit;
        };
        const incrementLightboxCookie = function () {
            Cookies.set(
                lightboxIdValue,
                checkTimesLightboxSeen() + oneView,
                {expires: daysUntilExpiry}
            );
        };
        const incrementGlobalLightboxCookie = function () {
            Cookies.set(
                globalLightboxCounter,
                checkTimesGlobalLightboxSeen() + oneView,
                {expires: daysUntilExpiry}
            );
        };
        const showLightbox = function (loDelay) {
            setTimeout(function () {
                    $('#' + lightboxIdValue).show();
                    incrementLightboxCookie();
                    incrementGlobalLightboxCookie();
                },
                loDelay);
        };
        if (isLimitReached(globalLightboxViewsLimit, lightboxViewsLimit) || isDialogVisible())
            return;
        showLightbox(delay);
    });
})(window.jQuery, window.Cookies);
